<mat-list role="list">
  @for (item of items(); track item) {
    <div class="item-container">
      <mat-list-item (dragover)="allowDrop($event)"
        draggable="true"
        (dragstart)="drag($event, item.name)">
        <span class="col-12">{{ item.name }}</span>
      </mat-list-item>
    </div>
  }
</mat-list>
